import { useCartItems } from "@checkout-v2/shared/hooks/useCartItems";
import { checkIfSubscriptionOrder } from "@checkout-v2/shared/utils/checkIfSubscriptionOrder";

export const useCartSubscriptionStatus = (): boolean | undefined => {
  const { data, isLoading, error } = useCartItems();

  return isLoading || error ? undefined : checkIfSubscriptionOrder(data);
};
